import { Reveal, Overline } from "@/components/Reveal";
import { PetitionCTA } from "@/components/PetitionCTA";

const ARGUMENTS = [
  {
    nr: "01",
    title: "Direct uitvoerbaar",
    body: "Er hoeft geen nieuwe snelweg, tunnel of groot geluidsscherm voor te worden gebouwd.",
    span: "md:col-span-7",
  },
  {
    nr: "02",
    title: "Effect over het hele traject",
    body: "Een snelheidsverlaging werkt niet alleen bij één woning of één geluidsscherm, maar langs het volledige betreffende traject.",
    span: "md:col-span-5",
  },
  {
    nr: "03",
    title: "Dag én nacht",
    body: "Een structurele limiet kan ook buiten de spits bijdragen aan een rustigere omgeving.",
    span: "md:col-span-5",
  },
  {
    nr: "04",
    title: "Beperkte impact op reistijd",
    body: "Over ongeveer zeven kilometer bedraagt het theoretische tijdsverschil ongeveer één minuut.",
    span: "md:col-span-7",
  },
];

export const Why80 = () => (
  <section id="waarom-80" data-testid="why80-section" className="scroll-mt-24 py-24 md:py-32">
    <div className="mx-auto max-w-[90rem] px-5 md:px-12">
      <Reveal>
        <Overline>De aanpak</Overline>
        <h2 className="mt-4 max-w-3xl font-display text-3xl font-medium leading-tight tracking-tight text-gooi-green md:text-5xl lg:text-6xl">
          Waarom vragen we om 80 km/u?
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-12 md:gap-8">
        {ARGUMENTS.map((arg, i) => (
          <Reveal key={arg.nr} delay={i * 0.1} className={arg.span}>
            <article
              data-testid={`why80-argument-${arg.nr}`}
              className="group h-full rounded-2xl border border-gooi-green/15 p-8 transition-colors duration-500 hover:bg-gooi-sand md:p-10"
            >
              <p className="font-display text-sm font-semibold tracking-[0.2em] text-gooi-red">{arg.nr}</p>
              <h3 className="mt-4 font-display text-xl font-medium tracking-tight text-gooi-green md:text-3xl">
                {arg.title}
              </h3>
              <p className="mt-4 max-w-lg text-sm leading-relaxed text-gooi-green/75 md:text-base">{arg.body}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <blockquote className="mt-20 max-w-4xl border-l-2 border-gooi-red pl-6 md:pl-10">
          <p className="font-display text-2xl font-medium leading-snug tracking-tight text-gooi-green md:text-4xl">
            Een minuut is klein achter het stuur. Iedere dag minder geluid is groot als je ernaast woont.
          </p>
        </blockquote>
        <div className="mt-10">
          <PetitionCTA location="why" size="xl">
            Ik steun 80 km/u – teken de petitie
          </PetitionCTA>
        </div>
      </Reveal>
    </div>
  </section>
);
